import React from "react"
import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Container from "../components/container"
import AstroSVG from "../images/gatsby-astronaut-svg.svg"
import Page from "../components/page"
import styled from "@emotion/styled"
import { graphql, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const Styles = styled.div`
  padding: 84px 0px;
  
  .astronaut {
    position: relative;
    overflow: hidden;
    max-width: 380px;
    display: block;
    margin: 48px auto;
    

    @media screen and (max-width: 550px) {
      max-width: 59vw;
    }
  }

  .secondary {
    padding: 40px 0px;
    background: #ececec;
  }

  .my-grid {
    display: grid;

    @media screen and (max-width: 440px) {
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    grid-gap: 38px;

    .first {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      padding-top: 24px;
    }

    li {
      border-top: 1px solid #dcdcdc;
      text-align: center;
      padding: 12px;
      color: #969696;
      font-size: 20px;
    }

    hr {
      margin: 1rem 0px;
    }
  }
`

export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
    this.state.paddingTop = 100
    this.state.bottom = 0
  }
  componentDidMount() {
    
  }

  // window.onscroll = this.adjustGatsby.bind(this)
  // adjustGatsby() {
  //   this.setState({
  //     bottom: window.scrollY / 4,
  //     // width: 194 + window.scrollY / 4,
  //   })
  // }

  render() {
    const image = this.props.data.astronaut.childImageSharp.fluid
    const stars = this.props.data.stars.childImageSharp.fluid

    return (
      <Layout path="/">
        <SEO title="Home" />
        <Styles>
            {/* <BackgroundImage
              Tag="section"
              fluid={stars}
              backgroundColor={`#000000`}
              style={{ backgroundAttachment: "fixed", minHeight: "80vh", paddingTop: this.state.paddingTop}}
            > */}
              <Img
                fluid={image}
                className="astronaut"
                alt="Astronaut"
              />

            {/* </BackgroundImage> */}

            <div className="secondary">
              <Container>
                <div className="title has-text-centered">
                  Who's It For
                </div>
                <div className="my-grid">
                  <div className="first">
                    <div className="title is-4 has-text-centered">
                      Developers
                    </div>
                    <ul>
                      <li>Client ready web apps</li>
                      <li>PWAs</li>
                      <li>Serverless Architecture</li>
                      <li>Performance</li>
                    </ul>
                  </div>

                  <div className="first">
                    <div className="title is-4 has-text-centered">
                      Designers
                    </div>
                    <ul>
                      <li>Integrate</li>
                      <li>SVG equipped layouts</li>
                      <li>Animate</li>
                    </ul>
                  </div>

                  <div className="first">
                    <div className="title is-4 has-text-centered">Students</div>
                    <ul>
                      <li>Free</li>
                      <li>Open-source</li>
                    </ul>
                  </div>
                </div>
              </Container>
            </div>
        </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    astronaut: file(relativePath: { eq: "gatsby-astronaut.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    stars: file(relativePath: { eq: "stars.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
